import languageRu from '../../uni-credit-language/uni-credit-language-ru';
import footerRu from '../../uni-credit-footer/uni-credit-footer-ru';
import dateRu from '../../uni-credit-date-field/uni-credit-date-field-ru';
import otpFormRu from '../../uni-credit-otp-form/locales/uni-credit-otp-form-ru';
import scratchCardRu from '../../uni-credit-scratch-card/locales/uni-credit-scratch-card-ru';
import accessBlockedRu from '../../uni-credit-access-blocked/locales/uni-credit-access-blocked-ru';
import notPossibleRu from '../../uni-credit-not-possible/locales/uni-credit-not-possible-ru';
import timerRu from '../../uni-credit-timer/locales/uni-credit-timer-ru';
import createAndConfirmPasswordRu from '../../uni-credit-create-and-confirm-password/locales/uni-credit-create-and-confirm-password-ru';
import createLoginRu from '../../uni-credit-create-login/locales/uni-credit-create-login-ru';
import contactBankRu from '../../uni-credit-contact-bank/locales/uni-credit-contact-bank-ru';
import findBankOfficeRu from '../../uni-credit-find-bank-office/locales/uni-credit-find-bank-office-ru';

const locales = {
  ...languageRu,
  ...footerRu,
  ...dateRu,
  ...otpFormRu,
  ...scratchCardRu,
  ...accessBlockedRu,
  ...notPossibleRu,
  ...findBankOfficeRu,
  ...contactBankRu,
  ...timerRu,
  ...createAndConfirmPasswordRu,
  ...createLoginRu,
};

export default locales;
